var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUpFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5L6 7.5V16.5H6.5H9H12H14L15 16L15.5 15L16 13L16.5 10.5L17 9L16.5 8.5L16 7.5H15H12H11.5L11 7V6L11.5 4V2.5H10.5L9.5 3L8.5 5Z",
    fill: "#2E2E38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1492 3.16726C10.8295 2.76767 10.2094 2.80938 9.94614 3.24818L7.68745 7.01266C7.27329 7.70292 6.52734 8.12528 5.72236 8.12528H3.54102V16.0419H13.7264C14.1961 16.0419 14.6077 15.7275 14.7313 15.2744L16.3222 9.44102C16.5029 8.77838 16.0041 8.12528 15.3173 8.12528H11.5047C10.7511 8.12528 10.2106 7.39882 10.4271 6.67701L11.2792 3.83698C11.3485 3.60595 11.2999 3.35561 11.1492 3.16726ZM12.1253 2.38639C11.2615 1.30659 9.58573 1.4193 8.87428 2.60506L6.61559 6.36954C6.42733 6.6833 6.08826 6.87528 5.72236 6.87528H3.41602C2.7947 6.87528 2.29102 7.37895 2.29102 8.00028V16.1669C2.29102 16.7883 2.7947 17.2919 3.41602 17.2919H13.7264C14.7598 17.2919 15.6654 16.6003 15.9373 15.6033L17.5282 9.76992C17.9258 8.3121 16.8283 6.87528 15.3173 6.87528H11.6727L12.4764 4.19616C12.6637 3.57185 12.5325 2.89536 12.1253 2.38639Z",
    fill: "#2E2E38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83268 17.2919C5.4875 17.2919 5.20768 17.0121 5.20768 16.6669V7.50028C5.20768 7.1551 5.4875 6.87528 5.83268 6.87528C6.17786 6.87528 6.45768 7.1551 6.45768 7.50028V16.6669C6.45768 17.0121 6.17786 17.2919 5.83268 17.2919Z",
    fill: "#2E2E38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpFilled);
export default __webpack_public_path__ + "static/media/thumbs-up-filled.2cab4d77319899baed3aecf030a771ca.svg";
export { ForwardRef as ReactComponent };